import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {StorageService} from './storage.service';

export interface EmailInList {
    enabled: boolean;
    onlyForUsers: string[] | null;
}

@Injectable({ providedIn: 'root' })
export class SettingsService {
    constructor(
        private storage: StorageService,
    ) {
    }

    get apiUrl(): string {
        return environment.apiUrl;
    }

    get wssUrl(): string {
        return environment.wssUrl;
    }

    get production(): boolean {
        return environment.production;
    }

    get googleCaptchaKey(): string {
        return environment.googleCaptchaKey;
    }

    get hideRecaptcha(): boolean {
        return false//['localhost', '127.0.0.1'].includes(window.location.hostname);
    }

    get logLevel(): number {
        return environment.logLevel;
    }

    get gaEnabled(): boolean {
        return environment.gaEnabled;
    }
    get promoterEnabled(): boolean {
        return environment.promoterEnabled;
    }
    get botUrl(): string {
        return environment.botUrl;
    }
    get refreshOnRecalculatedEvent(): boolean {
        return environment.refreshOnRecalculatedEvent;
    }

    get moniteEnabled(): boolean {
        return this.checkEmailInList(environment.monite);
    }

    get ebicsEnabled(): boolean {
        return this.checkEmailInList(environment.banksApi.ebics);
    }

    get banksApiEnabled(): boolean {
        return this.checkEmailInList(environment.banksApi.banksApi);
    }

    get shopifyEnabled(): boolean {
        return this.checkEmailInList(environment.shopify);
    }

    get bankingEnabled(): boolean {
        return this.checkEmailInList(environment.banking);
    }

    get cashBurnChartsEnabled(): boolean {
        return this.checkEmailInList(environment.cashBurnCharts);
    }

    get datevExportEnabled(): boolean {
        return this.checkEmailInList(environment.datevExport);
    }

    get goCardlessAllBanksEnabled(): boolean {
        return this.checkEmailInList(environment.goCardlessAllBanks);
    }

    checkEmailInList(widget?: EmailInList): boolean {
        return widget &&
            widget.enabled
            && (
                !widget.onlyForUsers ||
                widget.onlyForUsers?.indexOf(this.storage.userEmail) >= 0 ||
                widget.onlyForUsers?.findIndex(
                    email =>
                        email.includes('*') &&
                        email.split('*').every(part => this.storage.userEmail.includes(part))
                ) >= 0
            );
    }
}
